module.exports = __webpack_public_path__ + "media/images/index/service-icon-right-adac4fd4fa8ae472e1754f1b1721eaf9.svg";